import { render, staticRenderFns } from "./RvsSpectrumGraph.vue?vue&type=template&id=0064b9a4&scoped=true"
import script from "./RvsSpectrumGraph.vue?vue&type=script&lang=ts"
export * from "./RvsSpectrumGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064b9a4",
  null
  
)

export default component.exports